<main class="main">
    <molla-page-header title="Shopping Cart" subtitle=""></molla-page-header>

    <nav class="breadcrumb-nav">
        <div class="container">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">
                    <a routerLink="/">Home</a>
                </li>
                <!--
                <li class="breadcrumb-item">
                    <a routerLink="/shop/sidebar/3cols">Shop</a>
                </li>
                -->
                <li class="breadcrumb-item active">Shopping Cart</li>
            </ol>
        </div>
    </nav>

    <div class="page-content">
        <div class="cart">
            <div class="container">
                <div class="row" *ngIf="cartItems.length == 0 else cartBlock">
                    <div class="col-12">
                        <div class="cart-empty-page text-center">
                            <i class="cart-empty icon-shopping-cart cart-style" ></i>
                            <p class="px-3 py-2 cart-empty mb-3">No products added to the cart</p>
                            <p class="return-to-shop mb-0">
                                <a routerLink="/shop/sidebar/list" class="btn btn-primary">RETURN TO SHOP</a>
                            </p>
                        </div>
                    </div>
                </div>
                <ng-template #cartBlock>
                    <div class="row">
                        <div class="col-lg-9">
                            <table class="table table-cart table-mobile">
                                <thead>
                                    <tr>
                                        <th>Product</th>
                                        <th>Price</th>
                                        <th>Quantity</th>
                                        <th>Total</th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let product of cartItems; trackBy : trackByFn">
                                        <td class="product-col">
                                            <div class="product">
                                                <figure class="product-media">
                                                    <a [routerLink]="['/product/default/'+ product.id]">
                                                        <molla-image [src]="SERVER_URL + product.sm_pictures[0].url"
                                                            alt="Product">
                                                        </molla-image>
                                                    </a>
                                                </figure>

                                                <h3 class="product-title">
                                                    <a
                                                        [routerLink]="['/product/default/'+ product.id]">{{ product.name }}</a>
                                                </h3>
                                            </div>
                                        </td>
                                        <td class="price-col">
                                            {{ ( product.sale_price ? product.sale_price.toFixed( 2 ) : product.price.toFixed( 2 ) ) | currency:'EUR' }}
                                        </td>
                                        <td class="quantity-col">
                                            <molla-quantity-input adClass="cart-product-quantity" [value]="product.qty"
                                                [max]="product.stock" (changeQty)="onChangeQty( $event, product )">
                                            </molla-quantity-input>
                                        </td>
                                        <td class="total-col">{{ product.sum | currency:'EUR' }}</td>
                                        <td class="remove-col"><button class="btn-remove"
                                                (click)="cartService.removeFromCart( product )"><i
                                                    class="icon-close"></i></button></td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="cart-bottom">
                                <!--
                                <div class="cart-discount">
                                    <form action="#">
                                        <div class="input-group">
                                            <input type="text" class="form-control" required placeholder="coupon code">
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary-2" type="submit"><i
                                                        class="icon-long-arrow-right"></i></button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                -->

                                <a href="javascript:;" class="btn btn-outline-dark-2 btn-cart-update disabled"
                                    (click)="updateCart( $event )"><span>UPDATE CART</span><i
                                        class="icon-refresh"></i></a>
                            </div>
                        </div>
                        <aside class="col-lg-3">
                            <div class="summary summary-cart">
                                <h3 class="summary-title">Cart Total</h3>

                                <table class="table table-summary">
                                    <tbody>
                                        <tr class="summary-subtotal">
                                            <td>Subtotal:</td>
                                            <td>€{{ (cartService.priceTotal | async).toFixed(2)  }}
                                            </td>
                                        </tr>

                                        <tr class="summary-shipping" *ngIf="dtShipping.length>0">
                                            <td>Shipping:</td>
                                            <td>&nbsp;</td>
                                        </tr>

                                        <tr class="summary-shipping-row" *ngFor="let shipping of dtShipping">
                                            <td>
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="{{shipping.CODE}}" name="shipping"
                                                        class="custom-control-input" (change)="changeShipping(shipping.SHIPPING_COST,shipping.DESCRIPTION,shipping.ID,shipping.SHIPPING_LIMIT)">                                                        
                                                    <label class="custom-control-label" for="{{shipping.CODE}}">{{shipping.DESCRIPTION}}</label>
                                                </div>
                                            </td>
                                            <td *ngIf=" (cartService.priceTotal | async).toFixed(2) < shipping.SHIPPING_LIMIT">€{{shipping.SHIPPING_COST.toFixed(2)}}</td>
                                            <td *ngIf=" (cartService.priceTotal | async).toFixed(2) >= shipping.SHIPPING_LIMIT">€0</td>                                            
                                        </tr>
                                        <!--
                                        <tr class="summary-shipping-row">
                                            <td>
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="standart-shipping" name="shipping"
                                                        class="custom-control-input" (change)="changeShipping(10)">
                                                    <label class="custom-control-label"
                                                        for="standart-shipping">Standard:</label>
                                                </div>
                                            </td>
                                            <td>€10.00</td>
                                        </tr>

                                        <tr class="summary-shipping-row">
                                            <td>
                                                <div class="custom-control custom-radio">
                                                    <input type="radio" id="express-shipping" name="shipping"
                                                        class="custom-control-input" (change)="changeShipping(20)">
                                                    <label class="custom-control-label"
                                                        for="express-shipping">Express:</label>
                                                </div>
                                            </td>
                                            <td>€20.00</td>
                                        </tr>
                                        -->
                                        <!--
                                        <tr class="summary-shipping-estimate">
                                            <td>Estimate for Your Country<br> <a routerLink="/shop/dashboard">Change
                                                    address</a></td>
                                            <td>&nbsp;</td>
                                        </tr>
                                        -->
                                        <br>
                                        <tr *ngIf="apiService.showPoints">                                            
                                            <molla-accordion adClass="accordion-summary points" id="accordion-points" ><!--accordion-summary-->
                                                <div class="card">
                                                    <div class="card-header" id="heading-1"><!---->
                                                        <a class="toggle-button collapsed points" role="button" data-toggle="collapse"
                                                            href="#collapse-111" aria-expanded="false" aria-controls="collapse-1">
                                                            Redeem Points?
                                                        </a>                                                           
                                                    </div>
                                                    <div id="collapse-111" class="collapse" aria-labelledby="heading-3"
                                                        data-parent="#accordion-points">
                                                        <div class="card-body">
                                                            <tr class="points">
                                                                <td>Redeem Points:</td>
                                                                <td><input type="number" class="points-btn"  (keyup)="changeClicked()" #points2Redeem></td>
                                                            </tr>
                                                        </div>
                                                    </div>
                                                </div>
                                            </molla-accordion>                                                                                    
                                        </tr>

                                        <tr class="summary-total">
                                            <td>Total:</td>
                                            <td>€{{ ((cartService.priceTotal | async) + apiService.shippingCost - this.apiService.redeemPoints).toFixed(2) }}</td>
                                        </tr>

                                        
                                    </tbody>
                                </table>

                                <!-- <a routerLink="/shop/checkout" -->
                                    <div class="btn btn-outline-primary-2 btn-order btn-block" (click)="isOneChecked()">PROCEED TO CHECKOUT</div>
                            </div>

                            <a routerLink="/shop/sidebar/list"
                                class="btn btn-outline-dark-2 btn-block mb-3"><span>CONTINUE
                                    SHOPPING</span><i class="icon-refresh"></i></a>
                        </aside>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</main>